import { render, staticRenderFns } from "./oxonium-ionen.vue?vue&type=template&id=13981bee&"
import script from "./oxonium-ionen.vue?vue&type=script&lang=js&"
export * from "./oxonium-ionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports